import { render } from "./NewsPage.vue?vue&type=template&id=7dab63fe&scoped=true"
import script from "./NewsPage.vue?vue&type=script&lang=js"
export * from "./NewsPage.vue?vue&type=script&lang=js"

import "./NewsPage.vue?vue&type=style&index=0&id=7dab63fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dab63fe"]])

export default __exports__